/**
 * Sentry identity tags, set outside MainLayout so widget routes get them too — those
 * routes render outside the main shell, and a tag that shell sets never reaches them.
 */
export const tagSentryIdentity = (Sentry, profile) => {
  if (!Sentry || !profile) {
    return false
  }

  try {
    Sentry.setTag('id', profile.id)
    Sentry.setTag('name', profile.name)
    Sentry.setTag('company_name', profile.company_name)

    // A profile can arrive before the company resolves, and a tag set to undefined reads
    // in Sentry the same as one never set.
    if (profile.company_id) {
      Sentry.setTag('company_id', profile.company_id)
    }

    return true
  } catch (e) {
    // Tagging is diagnostics — never rethrow, so a widget still loads and places calls.
    console.warn('Talk-Bootstrap: Sentry identity tagging failed', {
      company_id: profile.company_id,
      user_id: profile.id,
      error: e
    })

    return false
  }
}

/**
 * Vuex subscriber tagging identity on every profile write. auth/SET_PROFILE is the single
 * mutation every surface's profile arrives through, including a sign-in mid-session.
 */
export const createSentryIdentitySubscriber = (Sentry) => (mutation, state) => {
  if (mutation?.type !== 'auth/SET_PROFILE') {
    return
  }

  // The merged profile, not mutation.payload: SET_PROFILE merges whatever keys it is
  // handed, so a partial write would blank a tag that was already correct.
  tagSentryIdentity(Sentry, state?.auth?.profile)
}
